import React from "react";
import { DashboardLayout } from "../../layout";
import { NavigationTabs, LeagueNavigation, Table } from "./components";


const Standings = () => {
  return (
    <DashboardLayout page="standings">
      <div className="hidden lg:block">
        <NavigationTabs />
        <div className="mt-10">
          <LeagueNavigation />
        </div>
        <div className="mt-10">
          <Table />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Standings;
